// Leaf module on purpose: `utils/router.ts` needs this enum, and importing it from
// `utils/trademark/constants.ts` dragged that module's tail — application-draft constants,
// trademark types, document constants — into every bundle that imports `routeTo`.
export enum TrademarkNumberType {
  number = 'number',
  registrationNumber = 'registrationNumber',
  internationalNumber = 'internationalNumber',
}
